
//
// This is a js port of the php method of Muestra::getPendingStatusAttribute()
//

(function(){

    function is_null(x){
        return !x;
    }

    ws.getPendingStatusAttribute = function(mi){

        let trans = window.trans;
        if(!trans){
            trans = x => "Missing JS trans ('" + x + "')";
        }


        // Waiting for sample
        // Lab - Sample received
        // Lab - Extracting DNA
        // Bioinformatics - Sequencing
        // Quality control

        let current_stage, current_stage_name, current_stage_icon;

        if(!mi.received_in_lab) {

            current_stage = 0;
            current_stage_name = trans('common::utils.sample_stages.waiting');
            current_stage_icon = 'icon-truck';

        } else if ( is_null(mi.dna_extraction) && mi.dna_extraction_at_origin === false ) {

            current_stage = 1;
            current_stage_name = trans('common::utils.sample_stages.lab_received');
            current_stage_icon = 'icon-sample';

        } else if (mi.chain_16s && is_null(mi.run_16s_date) || mi.chain_its && is_null(mi.run_its_date) || mi.chain_other && is_null(mi.other_finish_lab)) {

            current_stage = 1;
            current_stage_name = trans('common::utils.sample_stages.lab_extracting');
            current_stage_icon = 'icon-sample';


        } else if (mi.chain_16s && is_null(mi.run_samples_id_16s) || mi.chain_its && is_null(mi.run_samples_id_its) || mi.chain_other && is_null(mi.other_finish_lab)){

            current_stage = 2;
            current_stage_name = trans('common::utils.sample_stages.bioinformatics');
            current_stage_icon = 'icon-bioinf';

        } else {

            current_stage = 3;
            current_stage_name = trans('common::utils.sample_stages.quality');
            current_stage_icon = 'icon-icon_quality_control';
        }


        return {
            num_stages: 4,
            current_stage,
            current_stage_name,
            current_stage_icon,
        };

    };


})();

